import React, { useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';

import EmailAuthForm from '@/pages/Onboarding/components/EmailAuthForm/EmailAuthForm';
import { Product, getTheme } from '@/utils/productHelpers';
import { activateEmail } from '@/utils/sparkActivationApi';

interface EmailAuthLocationState {
  accessCode?: string;
  organizationSlug?: string;
}

const EmailAuthPage: React.FC = () => {
  const history = useHistory();
  const { product } = useParams<{ product: Product }>();
  const { state: locationState } = useLocation<EmailAuthLocationState>();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (email: string) => {
    setLoading(true);
    try {
      await activateEmail({
        email,
        product,
        accessCode: locationState?.accessCode,
        organizationSlug: locationState?.organizationSlug,
      });

      history.push(`/activate/${product}/check-email`, {
        email,
        accessCode: locationState?.accessCode,
        organizationSlug: locationState?.organizationSlug,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={getTheme(product)}>
      <EmailAuthForm onSubmit={handleSubmit} loading={loading} />
    </ThemeProvider>
  );
};

export default EmailAuthPage;
